import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { SpinnerService } from '../../services/spinner.service';
import { ApiGeneralText, ApiSetGeneralTextsRequest } from '../../api-client-module';
import { Language } from '../../firestore-models/language';

import { ApiClientService } from '../../api-client.service';
import { AppConst } from '../../app-const';

import { MultiGeneralTextDialogComponent } from '../../common/multi-general-text-dialog/multi-general-text-dialog.component';
import { TranslateService } from '@ngx-translate/core';

export interface GeneralTextDialogData {
  change_type: number;
  generalText?: ApiGeneralText;
}

@Component({
  selector: 'app-general-text-dialog',
  templateUrl: './general-text-dialog.component.html',
  styleUrls: ['./general-text-dialog.component.css'],
  standalone: false,
})
export class GeneralTextDialogComponent implements OnInit {

  //汎用テキスト情報
  generalText?: ApiGeneralText;
  isAdded: boolean = false;
  languages!: Array<Language>;

  //汎用テキスト情報フォーム
  generalTextFormGroup!: FormGroup;
  textIdControl!: FormControl;
  textsControl!: FormControl;

  currentLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<GeneralTextDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GeneralTextDialogData,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.generalText = this.data.generalText;
    if (!this.generalText) {
      this.generalText = {
        text_id: '',
        texts: [],
      };
      this.isAdded = true;
    }
    this.createForm();
    this.textIdControl = this.generalTextFormGroup.get('textId') as FormControl;
    this.textsControl = this.generalTextFormGroup.get('texts') as FormControl;
    this.currentLang = this.translate.currentLang;
  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToTextId() {
    return this.textIdControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.textIdControl.hasError('pattern')
          ? this.translate.instant('半角数字')
          : '';
  }

  public getErrorMessageToTexts() {
    return this.textsControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }


  //フォームの値を各要素に代入
  private createForm() {
    this.generalTextFormGroup = this.formBuilder.group(
      {
        textId: [this.generalText!.text_id, [Validators.required, Validators.pattern('^[0-9]+$')]],
        texts: [this.generalText!.texts, [Validators.required]]
      }
    );
  }

  //更新ボタン
  addGeneralText(): void {
    if (this.generalTextFormGroup.valid) {
      this.generalText!.text_id = this.textIdControl.value;
      this.generalText!.texts = this.textsControl.value;
      if (this.generalText) {
        let request: ApiSetGeneralTextsRequest = {
          access_token: '',
          change_type: this.data.change_type,
          general_texts: [this.generalText]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setGeneralTexts(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じIDが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  //汎用テキストダイアログ
  openGeneralTextDialog(): void {
    const dialogRef = this.dialog.open(MultiGeneralTextDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { texts: this.generalText!.texts }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.generalText!.texts = result.texts;
        this.textsControl.setValue(this.generalText!.texts);
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
